import React from 'react';

import styles from './index.module.scss';

import Header from '.';

const TroyHeader = ({ onTabChange, tabs, value, hasFilter, onFilterClear }) => (
  <Header {...{ styles, tabs, onTabChange, value, hasFilter, onFilterClear }} />
);

export default TroyHeader;
